import { render } from "./Customers.vue?vue&type=template&id=61f0df69&scoped=true"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"

import "./Customers.vue?vue&type=style&index=0&id=61f0df69&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-61f0df69"

export default script